module.exports = __webpack_public_path__ + "img/dropbox.8d06caa5.svg";